TopBar = {};
TopBar.selecionarEstruturaGestor = function () {
    var url = AGA.Ajax.getUrlPath("/rh/e/Gestor/SelecionarEstrutura.aspx?imp=1");
    Benner.ModalPage.show({
        id: "selecionarEstrutura",
        size: "large",
        height: 610,
        displayFooter: false,
        displayTitle: false,
        url: url
    },
    Benner.WidgetCommandsBar.openModal,
    Benner.WidgetCommandsBar.disposeModal);
    $("body").data("lazy-post-id", "ctl00_Body");
};